module.exports = __webpack_public_path__ + "static/media/0.7f684c25.jpg";